import { render, staticRenderFns } from "./politics.vue?vue&type=template&id=378ae96a&scoped=true&"
import script from "./politics.vue?vue&type=script&lang=js&"
export * from "./politics.vue?vue&type=script&lang=js&"
import style0 from "./politics.vue?vue&type=style&index=0&id=378ae96a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ae96a",
  null
  
)

export default component.exports